import { render, staticRenderFns } from "./BookletTile.vue?vue&type=template&id=61582016&scoped=true&"
import script from "./BookletTile.vue?vue&type=script&lang=ts&"
export * from "./BookletTile.vue?vue&type=script&lang=ts&"
import style0 from "./BookletTile.vue?vue&type=style&index=0&id=61582016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61582016",
  null
  
)

export default component.exports